import Describer from "../../../utils/issues/issue_description/describer";

function render(issue, topics) {
  const describer = new Describer.IssueDescriber(issue, topics);
  return `${describer.topicName} exists at least once with a parameter`;
}

export default render;
